import { ref } from 'vue'

export const useCoolDownHover = () => {
  const coolDown = ref(false)
  const isHovered = ref(false)

  const onMouseEnter = () => {
    isHovered.value = true
    coolDown.value = false
  }

  const onMouseLeave = (cb?: () => void) => {
    isHovered.value = false
    coolDown.value = true
    setTimeout(() => {
      if (coolDown.value && cb) {
        cb()
      }
    }, 1000)
  }

  return {
    isHovered,
    onMouseEnter,
    onMouseLeave,
  }
}
